import React from "react";
import { LayoutA } from "components/layouts";
import { ForgotPassword } from "modules";

const ForgotPasswordPage = () => {
  return (
    <LayoutA>
      <ForgotPassword />
    </LayoutA>
  );
};

export default ForgotPasswordPage;
